import React from 'react';
import PropTypes from 'prop-types';
import {getCartUrl, getOverview} from "./logic";
import SnowplowsCartIcon from "./SnowplowsCartIcon";
import TailwindCartIcon from "./TailwindCartIcon";

export default function CartIcon(
  {
    theme, ...props
  }) {

  // get dynamic cart overview or props passed in at startup
  let overview = getOverview(props);

  let cartUrl = getCartUrl(props);

  if (theme === "snowplows") {
    return <SnowplowsCartIcon {...overview} cartUrl={cartUrl}/>
  } else {
    // MODERN FLAVOUR
    return <TailwindCartIcon {...props} {...overview} cartUrl={cartUrl}/>
  }
}

CartIcon.propTypes = {
  overview: PropTypes.object,
  theme: PropTypes.string,
  currentAgent: PropTypes.object,
  shoppingCart: PropTypes.object
};
